const validatorStyle = {
  textField: {
    /* Hack until MUI upgrade! */
    "& .MuiInput-root": {
      paddingBottom: "7px !important"
    },
  }
}
export default validatorStyle;
